import { SUGGESTIONS_REQUEST } from "./const";

function action(term) {
  return {
    type: SUGGESTIONS_REQUEST,
    term,
  };
}

export default action;
